@if (rejectedPrescriptionIds) {
  <div class="mt-3">Rejected Prescriptions: {{ clientTaskHistoryItem.data.rejectedPrescriptionIds | joinList }}</div>
} @else {
  <div class="mt-3">Rejected Prescriptions: None</div>
}
